module.exports = __webpack_public_path__ + "img/card_pet_grooming_200.3d4b9fce.jpg";